<user-contact-ingot
  [user]="user"
  [link]="user | k2UserLink"
></user-contact-ingot>
